import { useContext } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";

import { AssetUploadContext } from "context/AssetUploadContext";
import useFileSelector from "hooks/useFileSelector";

export default function useAssetUploader({ assetType, accept = "", multiple = true }){
	/*
		This hook returns a configured function that can be called to launch a file selection,
		and then queries the API for name conflicts in the current library to be processed.

		If conflicts are found, it will open a modal for the user to specify what to do about
		each conflict.

		If no conflicts are found, it will just dispatch a bulk upload request.
	*/
	const { libraryId } = useParams();
	const { stageUpload } = useContext(AssetUploadContext);
	const libraryName = useSelector(state => state.libraryProperties.name);

	return useFileSelector(
		(e) => {
			let fileList = e.currentTarget.files;
			stageUpload(assetType, libraryId, libraryName, fileList);
		},
		{
			accept,
			multiple,
		}
	);
}
